export default __webpack_public_path__ + "static/media/videoAvatar.2c92d012.mp4";